import { DropdownData, type ReactiveDropdownDataProvenance } from '../../interfaces/input.interface';
import type { ReactiveDropdownCacheStatus } from '../../interfaces/reactive-field-runtime-state.interface';
import {
  ReactiveDropdownCacheConfig,
  ReactiveDropdownCacheService,
} from '../reactive-dropdown-cache.service';

export class ReactiveDropdownCacheCoordinator {

  public constructor(private readonly dropdownCache: ReactiveDropdownCacheService) {}

  public restore(cacheConfig: ReactiveDropdownCacheConfig, data: DropdownData<unknown>): boolean {
    if (!this.dropdownCache.restore(cacheConfig, data)) {
      return false;
    }

    this.setProvenance(data, 'cache');

    return true;
  }

  public saveIfAllowed(cacheConfig: ReactiveDropdownCacheConfig, data: DropdownData<unknown>): ReactiveDropdownCacheStatus {
    if (!this.shouldSave(data)) {
      return 'skipped';
    }

    this.dropdownCache.save(cacheConfig, data);

    return 'saved';
  }

  public save(cacheConfig: ReactiveDropdownCacheConfig, data: DropdownData<unknown>): void {
    this.dropdownCache.save(cacheConfig, data);
  }

  public clear(cacheConfig: ReactiveDropdownCacheConfig): void {
    this.dropdownCache.clear(cacheConfig);
  }

  public shouldSave(data: DropdownData<unknown>): boolean {
    return this.resolveProvenance(data) !== 'hydrationSeed';
  }

  public withProvenance(
    data: DropdownData<unknown>,
    provenance: ReactiveDropdownDataProvenance,
  ): DropdownData<unknown> {
    this.setProvenance(data, provenance);

    return data;
  }

  public setProvenance(data: DropdownData<unknown>, provenance: ReactiveDropdownDataProvenance): void {
    data.provenance = provenance;
  }

  public resolveProvenance(data: DropdownData<unknown>): ReactiveDropdownDataProvenance {
    return data.provenance ?? 'manual';
  }
}
